import merge from 'deepmerge'
import ProductMessages from './messages/ProductMessages'
import OrderMessages from './messages/OrderMessages'
import OrderStateMessages from './messages/OrderStateMessages'
import IngredientMessages from './messages/IngredientMessages'
import ProductCategoryMessages from './messages/ProductCategoryMessages'
import BranchMessages from './messages/BranchMessages'
import StockMessages from './messages/StockMessages'
import StockTransactionMessages from './messages/StockTransactionMessages'
import StockDailyMessages from './messages/StockDailyMessages'
import DailyBoxMessages from './messages/DailyBoxMessages'
import PromoMessages from './messages/PromoMessages'
import SurveysMessages from './messages/SurveysMessages'
import CouponMessages from './messages/CouponMessages'
import SalesReportMessages from './messages/SalesReportMessages'
import DeliveryPermissionMessages from './permissions/DeliveryPermissionMessages'


const messages = merge.all([
    ProductMessages,
    OrderMessages,
    OrderStateMessages,
    IngredientMessages,
    ProductCategoryMessages,
    BranchMessages,
    StockMessages,
    StockTransactionMessages,
    StockDailyMessages,
    DailyBoxMessages,
    PromoMessages,
    SurveysMessages,
    CouponMessages,
    SalesReportMessages,
    DeliveryPermissionMessages
])

export default messages;
